// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var sectionContainer = "TextAndImageSection-module--sectionContainer--2OhV8";
export var noPaddingTop = "TextAndImageSection-module--noPaddingTop--15Yq8";
export var section = "TextAndImageSection-module--section--2BL5k";
export var textAndImageContainer = "TextAndImageSection-module--textAndImageContainer--2wDKd";
export var withRectangularImage = "TextAndImageSection-module--withRectangularImage--2Aq5C";
export var noImage = "TextAndImageSection-module--noImage--2NEBT";
export var imageOnLeft = "TextAndImageSection-module--imageOnLeft--2RZyB";
export var textContainer = "TextAndImageSection-module--textContainer--3khUn";
export var rectangularImage = "TextAndImageSection-module--rectangularImage--2TYYH";
export var noMobileImage = "TextAndImageSection-module--noMobileImage--1n6UD";
export var anchoredImage = "TextAndImageSection-module--anchoredImage--2kJlc";
export var anchoredOnTop = "TextAndImageSection-module--anchoredOnTop--1SIhQ";
export var anchoredOnLeft = "TextAndImageSection-module--anchoredOnLeft--2hVNF";
export var anchoredOnBottom = "TextAndImageSection-module--anchoredOnBottom--3O6zU";
export var anchoredOnRight = "TextAndImageSection-module--anchoredOnRight--1MqHM";
export var mobileImageContainer = "TextAndImageSection-module--mobileImageContainer--2Hqma";